import { isNumber, isPrimitive } from 'radash';
import { parseFlexAlignment } from '../parsers/flex.js';

/**
 * Generates CSS for applying a minimum height to an element.
 *
 * @param options - Options for the mixin.
 */ function flexItem(options) {
    const { align, grow, order, shrink, width } = options;
    const resolvedWidth = isNumber(width) && width > 0 && width < 1 ? `${width * 100}%` : width ?? 0;
    return ()=>[
            align && {
                alignSelf: parseFlexAlignment(align)
            },
            grow && {
                flexBasis: 0,
                flexGrow: 1,
                flexShrink: 1
            },
            order && {
                order
            },
            isPrimitive(shrink) && {
                flexShrink: shrink ? 1 : 0
            },
            width && {
                width: resolvedWidth
            }
        ];
}

export { flexItem };
//# sourceMappingURL=flex-item.js.map
